/*jshint multistr: true */
if ($("body.index").length > 0) {
  $(window).scroll(function() {
    if ($(this).scrollTop() > 448){  
      $('header,.header-stub').addClass("sticky");
      $('body > navbar').addClass("invisible");
    }
    else{
      $('header,.header-stub').removeClass("sticky");
      $('body > navbar').removeClass("invisible");
    }
  });
}
$.ajaxSetup({
  cache: true
});
if ( ($(window).height() + 100) < $(document).height() ) {
  $('#top-link-block').removeClass('hidden').affix({
      offset: {top:100}
  });
}
$('#top-link-block').click(function () {
  $('html,body').animate({scrollTop:0});return false;
});
$('.nav-toggle').popover({
  html: true,
  content: function () {
    return $("header .navbar ul,header .navbar form").clone();
  }
});
$('.partner2 .panel').click(function () {
  var link = $(this).find('a');
  if (link.length > 0) {
    window.location.href = link.attr('href');
  }
});
$('.img-click').popover({
  content: function () {
    var src = $(this).data("clicksrc");
    return '<img src="'+ src + '" style="width: 100%;"/>';
  },
  template: '<div class="popover" style="max-width: 50%;" role="tooltip"><div class="popover-content"></div></div>',
  container: "body",
  viewport: { selector: 'body > .container', padding: '20px' },
  html: true
});
